import { useState } from "react";
import { useSearchBox } from "react-instantsearch-core";
import { Input, InputSize } from "shared/components";

// Please take a look https://www.algolia.com/doc/api-reference/widgets/search-box/react/#hook-usage
interface CustomSearchBoxProps {
  clearSelectedRows: () => void;
}

export const CustomSearchBox = ({
  clearSelectedRows
}: CustomSearchBoxProps) => {
  const { refine, query } = useSearchBox();

  const [inputValue, setInputValue] = useState(query);

  function setQuery(newQuery) {
    setInputValue(newQuery);

    refine(newQuery);
    clearSelectedRows();
  }

  return (
    <Input
      id="search"
      placeholder="Search"
      className="!mb-0 w-[270px]"
      size={InputSize.SM}
      value={inputValue}
      onChange={(e) => setQuery(e.currentTarget.value)}
    />
  );
};
